import React from 'react'

import { Spinner } from '@acorns/web-components'
import styled from 'styled-components'

const Center = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const CenteredSpinner = () => (
  <Center>
    <Spinner />
  </Center>
)

export default CenteredSpinner
